import type { State } from '../types';

export const DEFAULT_AUTH_STATE: State = {
  isAuthorized: false,
  authTokens: null,
  address: '',
};
